import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Text, TextSize, TextType} from '@Components/text';
import {Button, Type} from '@Components/button';
import styles from './reprompt-camera-and-microphone-permission.module.scss';

interface RepromptCameraAndMicrophonePermissionProps {
  onInitiatePrompt: () => Promise<void>;
}

export function RepromptCameraAndMicrophonePermission({...props}: RepromptCameraAndMicrophonePermissionProps): ReactElement | null {
  return (
    <div className="_full-width _full-height flex-center spacing-p-16">
      <div className={`${styles.wrapper} flex-column-align-center flex-content-center`}>
        <Icon className="spacing-m-b-8" icon="icon-lock" type={IconType.FLAT} shape={IconShape.CIRCLE} size={IconSize.SIZE_ICON_32} />
        <Text className={`spacing-m-b-8 ${styles.centerText}`} val={window.i18next.t('pmwjs_allow_permissions_subtext')} type={TextType.BODY} size={TextSize.XSMALL} />
        <Button
          onClick={() => {
            void props.onInitiatePrompt();
          }}
          type={Type.SECONDARY}
          text={window.i18next.t('pmwjs_allow_permissions')}
        />
      </div>
    </div>
  );
}
